import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

/**
 * Action Service to analyses the complexity of a mix and match
 */
@Injectable()
export class MixAndMatchComplexityAnalysisService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "mix-and-match-complexity-analysis");
    }
}
